var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"role":"presentation","fill":"none"}},[_c('rect',{attrs:{"x":"2","y":"2","width":"20","height":"20","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }